<template>
  <b-container fluid>
    <div class="page-header">
      <b-col md="auto">
        <h1>
          Affiliated Groups
        </h1>
      </b-col>
      <b-row>
        <b-col md="3" class="my-2">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8">
          <b-table hover id="affiliatedGroupsTable"
                         :items="affiliatedGroupsToDisplay"
                         :fields="affiliatedGroupFields"
                         :perPage="perPage"
                         :current-page="currentPage"
                         @row-clicked="goToAffiliatedGroupDetails">
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="affiliatedGroupsToDisplay.length" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import AffiliatedGroupsProvider from '@/services/AffiliatedGroupsProvider'

export default {
  name: 'AffiliatedGroupsList',
  data () {
    return {
      affiliatedGroups: [],
      affiliatedGroupFields: [
        { key: 'name', sortable: true },
        { key: 'uuid', sortable: false }
      ],
      filter: '',
      perPage: 10,
      currentPage: 1
    }
  },
  mounted () {
    AffiliatedGroupsProvider.all()
      .then((resp) => {
        this.affiliatedGroups = resp.body.affiliated_groups
      })
  },
  computed: {
    affiliatedGroupsToDisplay () {
      return this.affiliatedGroups.filter(group => RegExp(this.filter, 'i').test(group.name))
    }
  },
  methods: {
    goToAffiliatedGroupDetails (row) {
      this.$router.push({ name: 'AffiliatedGroupDetails',
        params: { id: row.id }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #affiliatedGroupsTable tr:hover {
    cursor: pointer;
  }
</style>
